export type PromoCode = {
  name: string;
  description: string;
  active: boolean;
  valid_from: string;
  valid_until: string;
};
